import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  updateWaitingAreaNotifyRoomParticipants,
  updateWaitingAreaNotifyRoomParticipantsForm,
  updateSelectedVideoCallRoom,
} from '../../../../actions/waitingArea';
import { forceValidation, clearAllValidationErrors } from '../../../../businessLogic/validation.js';
import { updateShowNotifyRoomParticipant } from '../../../../actions/modal';
import { displayGlobalMessage } from '../../../../actions/globalMessage';

export default function RightPanelNotifyRoomParticipant(props) {
  const dispatch = useDispatch();
  const [sendingNotification, setSendingNotification] = useState(props.sendingNotification || false);
  useEffect(() => {
    resetForm();
  }, []);

  const sendNotificationToParticipants = (e) => {
    // Remove the space after caller's name is it has, for better UI display
    let callerName = props.participantRoomData.mainParticipant.name;
    if (/ $/.test(callerName)) {
      callerName = callerName.slice(0, -1);
    }
    let areThereErrors = forceValidation(undefined, undefined, 'notifyRoomParticipantForm');
    let cb = (value) => {
      if (value) {
        var successMessage = APP.LANGUAGE.NotifyCaller.Success.replace('##caller##', callerName);
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        cancelNotificationToParticipants();
      } else {
        setSendingNotification(false);
        var errorMessage = APP.LANGUAGE.NotifyCaller.ErrorSending;
        dispatch(
          displayGlobalMessage({
            text: errorMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
            autoHide: false,
          })
        );
      }
    };
    if (!areThereErrors && !window.$(e.target).hasClass('disable')) {
      setSendingNotification(true);
      dispatch(updateWaitingAreaNotifyRoomParticipants(props.participantRoomData, props.notifyRoomParticipants, cb));
    }
  };
  const cancelNotificationToParticipants = () => {
    resetForm();
    dispatch(updateShowNotifyRoomParticipant(false));
    dispatch(updateSelectedVideoCallRoom({}));
  };

  const resetForm = () => {
    setTimeout(() => {
      dispatch(updateWaitingAreaNotifyRoomParticipantsForm(''));
    }, 100); //wait until modal is inviisble
  };

  let cancelClassName =
    'ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrlnull mrbnull mrtsss';
  let saveClasses =
    'ui labeled icon button icon color-button color-button-hover color-white  max-width left-text mrlnull mrbs  disable';
  return (
    <div>
      <div className="ui actions mrbl max-width">
        <button
          tabIndex="1"
          type="button"
          onClick={sendNotificationToParticipants}
          data-group="notifyRoomParticipantForm"
          className={sendingNotification ? saveClasses + ' loading' : saveClasses}
        >
          <i className="send outline icon" />
          {APP.LANGUAGE.Send}
        </button>
        <button tabIndex="2" type="button" onClick={cancelNotificationToParticipants} className={cancelClassName}>
          <i className="remove  icon" /> {APP.LANGUAGE.Cancel}{' '}
        </button>
      </div>
    </div>
  );
}
